import React from 'react'; // eslint-disable-line
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _actions from '../../actions';
import i18n from '../../i18n';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import GreenCheck from '../../components/svg/GreenCheck';
import constants from '../../constants';
import ShareFaith from '../../assets/images/sharefaith.png';
import ManagedInput from '../../components/forms/ManagedInput';
import OnOffSwitch from '../../components/forms/OnOffSwitch';

class ShareFaithIntegration extends React.Component {
    timer = null;

    constructor(props) {
        super(props);

        this.disconnect = this.disconnect.bind(this);

        this.state = {
            memberEmail: '',
            isConnected: false,
            errorEmail: '',
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.integrations.sfLookupInProgress
            && !this.props.integrations.sfLookupInProgress) {
            if (this.props.integrations.sfMemberId && this.props.integrations.sfMemberId > 0) {
                this.selectedMember(this.props.integrations.sfMemberId);
            } else if (this.props.integrations.sferror
                && this.props.integrations.sferror.length > 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ errorEmail: 'An error occurred. Please try again or contact support.' });
            } else {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ errorEmail: 'This is not a valid Sharefaith account.' });
            }
        }

        if (prevProps.modules.allInProgress && !this.props.modules.allInProgress) {
            const devotionalModule = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Devotionals'; }).Id; });
            if (
                Array.isArray(devotionalModule) &&
                devotionalModule.length > 0 &&
                devotionalModule[0].shareFaithMemberId
                && devotionalModule[0].shareFaithMemberId > 0) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    memberEmail: devotionalModule[0].shareFaithMemberEmail,
                    isConnected: true,
                    errorEmail: '',
                });
            }
        }

        if (prevProps.modules.inProgress && !this.props.modules.inProgress) {
            const devotionalModule = this.props.modules.select;
            // use select because this only triggers on update of single module
            if (this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Devotionals'; }).Id) {
                if (devotionalModule.shareFaithMemberId
                    && devotionalModule.shareFaithMemberId > 0) {
                    const { memberEmail } = this.state;
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        memberEmail,
                        isConnected: true,
                        errorEmail: '',
                    });
                } else {
                    // eslint-disable-next-line react/no-did-update-set-state
                    this.setState({
                        memberEmail: '',
                        isConnected: false,
                    });
                }
            }
        }
    }

    updateSearch = (input) => {
        if (input !== '') {
            clearTimeout(this.timer);
            this.setState({
                errorEmail: '', memberEmail: input.target.value, isConnected: false,
            });
            this.timer = setTimeout(this.triggerChange, 1000);
        }
    }

    triggerChange = () => {
        const { memberEmail } = this.state;
        this.searchEmail(memberEmail);
    }

    toggleModule = (evt) => {
        this.props.modules.data = this.props.modules.data.map((module) => {
            if (module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Devotionals'; }).Id) {
                // eslint-disable-next-line no-param-reassign
                module.enabled = evt.target.checked;
                return module;
            } return module;
        });
        this.updateModuleForFieldWithValue('enabled', evt.target.checked);
    }

    updateModuleForFieldWithValue = (field, val) => {
        this.props.actions.updateModuleParameter(
            this.props.versions.select.projectId,
            constants.ModuleType.find((c) => { return c.Name === 'Devotionals'; }).Id,
            field,
            val,
        );
    }

    selectedMember = (sfid) => {
        const moduleParamArray = [
            { parameterName: 'shareFaithMemberEmail', parameterValue: this.state.memberEmail },
            { parameterName: 'shareFaithMemberId', parameterValue: sfid },
            { parameterName: 'enabled', parameterValue: true },
        ];
        this.props.actions.updateModule(this.props.versions.select.projectId, constants.ModuleType.find((c) => { return c.Name === 'Devotionals'; }).Id, moduleParamArray);
        this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Devotionals'; }).Id; })[0].enabled = true;
        this.setState({ isConnected: true });
    }

    searchEmail(email) {
        this.props.actions.checkShareFaithEmail(email);
    }

    disconnect() {
        const moduleParamArray = [
            { parameterName: 'shareFaithMemberEmail', parameterValue: null },
            { parameterName: 'shareFaithMemberId', parameterValue: 0 },
            { parameterName: 'enabled', parameterValue: false },
        ];
        this.props.actions.updateModule(this.props.versions.select.projectId, constants.ModuleType.find((c) => { return c.Name === 'Devotionals'; }).Id, moduleParamArray);
        this.setState({ memberEmail: null, isConnected: false });
    }

    render() {
        const devotionalModule = this.props.modules.data.filter((module) => { return module.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Devotionals'; }).Id; });
        const { isConnected } = this.state;
        const sfConnected = devotionalModule.length > 0 ? (
            <div id="sf-connected" className="sf-connected">
                <div className="sf-info show">
                    <GreenCheck />
                    <p>
                        Account:
                        <span>{this.state.memberEmail}</span>
                    </p>

                    {/* eslint-disable-next-line */}
                    <a id="disconnect-sf" className="btn btn-sq btn-outline btn-sm" onClick={() => { this.disconnect(); }}>{i18n.t('disconnect')}</a>
                </div>
                <div className="general-section module-display-settings-list">
                    <h2 className="section-name">{i18n.t('integrations.devotionals.connected-header')}</h2>
                    <p>{i18n.t('integrations.devotionals.connected-subtitle')}</p>
                    <HorizontalFormContainer inputClass="module-display-setting__toggle" title={i18n.t('integrations.devotionals.toggle-label')}>

                        <OnOffSwitch
                            id="enabled-tab"
                            buttonClass="toggle checkbox md-checkbox"
                            isToggleOn={devotionalModule[0].enabled}
                            name="enabled"
                            onChange={this.toggleModule}
                            dataQA="sharefaith"
                        />
                    </HorizontalFormContainer>
                </div>
            </div>
        ) : '';
        const sfDisconnected = (
            <div className="sf-disconnected">
                <div className="general-section module-display-settings-list">
                    <h2 className="section-name">{i18n.t('integrations.devotionals.disconnected-header')}</h2>
                    <p>{i18n.t('integrations.devotionals.disconnected-subtitle')}</p>

                    <div className="module-display-setting">
                        <HorizontalFormContainer
                            inputClass="module-display-setting__setting"
                            title=""
                        />
                        <ManagedInput
                            name="form-field-name"
                            onChange={(e) => { this.updateSearch(e); }}
                            placeholder={i18n.t('integrations.devotionals.placeholder')}
                        />
                        <div className="help">{this.state.errorEmail}</div>
                    </div>
                </div>
            </div>
        );

        // eslint-disable-next-line no-nested-ternary
        return !this.props.modules.allInProgress ? (devotionalModule.length > 0
            ? (
                <div className="sf-form">
                    <img height="50px" width="auto" alt="ShareFaith" src={ShareFaith} />
                    {isConnected ? sfConnected : sfDisconnected}
                </div>
            ) : '') : '';
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShareFaithIntegration);
